import { useContext, useState, useEffect } from 'react';
import { FaturadorContext } from '../../../../contexts/faturadorProvider';
import { ClientContext } from '../../../../contexts/clientProvider';
import LoadingSpinner from '../../../Loader/load';
import DataTable from '../../../Table';
import { handleImport, calculateResults, generatePDF, downloadNewSecAndData, generatePDFExcel } from '../Utils/mixerUtil';
import { UserContext } from '../../../../contexts/userProvider';
import NumberInput from '../../../General/FormsComp/Input/numberInput';
import BaseCheckbox from '../../../General/FormsComp/CheckBox/BaseCheckbox';
import BaseSelect from '../../../General/FormsComp/Select/BaseSelect';

// Função utilitária para deep clone
const deepClone = (obj) => {
    if (obj === null || typeof obj !== 'object') return obj;
    if (obj instanceof Date) return new Date(obj.getTime());
    if (obj instanceof Array) return obj.map(item => deepClone(item));
    if (typeof obj === 'object') {
        const clonedObj = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                clonedObj[key] = deepClone(obj[key]);
            }
        }
        return clonedObj;
    }
    return obj;
};

const Secretarias = () => {
    const { clientes, setIdCliente } = useContext(ClientContext);
    const { loading, clienteSelecionado, currSec, fetchSecs } = useContext(FaturadorContext);
    const { setAlert } = useContext(UserContext);

    // Estados locais com deep clone dos valores do context
    const [localClienteSelecionado, setLocalClienteSelecionado] = useState(null);
    const [localCurrSec, setLocalCurrSec] = useState([]);
    const [localLoading, setLocalLoading] = useState(false);

    const [titulo, setTitulo] = useState(null);
    const [imported, setImported] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [dataTable, setDataTable] = useState(null);
    const [isChecked, setIsChecked] = useState(false);

    const [vc1Value, setVc1Value] = useState(0.1023);
    const [vc2Value, setVc2Value] = useState(0.1023);
    const [vc3Value, setVc3Value] = useState(0.1136);
    const [lcValue, setLcValue] = useState(0.0341);
    const [ldnValue, setLdnValue] = useState(0.0682);

    // Sincronizar estados locais com o context quando necessário
    useEffect(() => {
        if (clienteSelecionado !== undefined) {
            setLocalClienteSelecionado(deepClone(clienteSelecionado));
        }
    }, [clienteSelecionado]);

    useEffect(() => {
        if (currSec !== undefined) {
            setLocalCurrSec(deepClone(currSec));
        }
    }, [currSec]);

    useEffect(() => {
        if (loading !== undefined) {
            setLocalLoading(loading);
        }
    }, [loading]);

    const gerenatePdf = async (id) => {
        let secretaria = dataTable.find((sec) => sec.id === id);
        let checkbox = document.getElementById('myCheckbox');
        let value = checkbox.checked;
        secretaria = { ...secretaria, remove: isChecked };
        await generatePDF(secretaria, titulo, value);
    }

    const generateExcel = (id) => {
        const secretaria = dataTable.find((sec) => sec.id === id);
        const secName = secretaria.secretaria ?? '';
        downloadNewSecAndData(secretaria.Detalhes[0].data, secName);
    }

    const generatePDFDetails = (id) => {
        const secretaria = dataTable.find((sec) => sec.id === id);
        let checkbox = document.getElementById('myCheckbox');
        let value = checkbox.checked;
        generatePDFExcel(secretaria, titulo, value);

    }

    const downloadAllPdfs = async () => {
        let checkbox = document.getElementById('myCheckbox');
        let value = checkbox.checked;
        for (const sec of dataTable) {
            await generatePDF(sec, titulo, value);
        }
    }

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
    };


    const headers = dataTable
        ? [
            { label: "Secretaria", key: "secretaria", sortable: true, wrapText: true, width: "w-48" },
            { label: "Linhas", key: "linhas", sortable: false, wrapText: true, width: "w-40" },
            { label: "T. VC1", key: "Tempo VC1", sortable: false, width: "w-20" },
            { label: "V. VC1", key: "Valor VC1", sortable: false, width: "w-24" },
            { label: "T. VC2", key: "Tempo VC2", sortable: false, width: "w-20" },
            { label: "V. VC2", key: "Valor VC2", sortable: false, width: "w-24" },
            { label: "T. VC3", key: "Tempo VC3", sortable: false, width: "w-20" },
            { label: "V. VC3", key: "Valor VC3", sortable: false, width: "w-24" },
            { label: "T. LC", key: "Tempo LC", sortable: false, width: "w-20" },
            { label: "V. LC", key: "Valor LC", sortable: false, width: "w-24" },
            { label: "T. LDN", key: "Tempo LDN", sortable: false, width: "w-20" },
            { label: "V. LDN", key: "Valor LDN", sortable: false, width: "w-24" },
            { label: "Fatura", key: "Fatura", sortable: false, width: "w-28" },
            { label: "SaperVal", key: "SaperVal", sortable: false, width: "w-28" },
            {
                label: "Ações", key: "actions", sortable: false,
                wrapText: true,
                actions: { "pdf": gerenatePdf, "pdfExcel": generatePDFDetails, "excel": generateExcel }, width: "w-38"
            },
        ]
        : [
            { label: "Secretaria", key: "secretaria", sortable: true, wrapText: true, width: "w-64" },
            { label: "Local", key: "local", sortable: false, wrapText: true, width: "w-48" },
            { label: "Endereço", key: "endereço", sortable: false, wrapText: true, width: "w-64" },
            { label: "Bairro", key: "bairro", sortable: false, width: "w-40" },
            { label: "Linhas", key: "linhas", sortable: false, wrapText: true, width: "w-40" },
        ];

    useEffect(() => {
        if (localClienteSelecionado) {
            const sel = localClienteSelecionado;
            setTitulo(sel);
        }
    }, [localClienteSelecionado]);

    const handleSelectClient = async (e) => {
        const id = e.target.value;
        setTitulo(e.target.value);
        setLocalClienteSelecionado(e.target.value);
        let data = await fetchSecs();
        let dados = data?.[0];
        if (dados.erpID == id) {
            let { secretarias } = dados;
            // Atualiza apenas o estado local, não afeta o context
            setLocalCurrSec(deepClone(secretarias).map((sec, i) => ({ ...sec, id: i + 1 })));
        }
        else {
            setLocalCurrSec([]);
        }

    };

    const handleFileChange = (e) => {
        const file = e?.target?.files[0];
        if (file) {
            const fileType = file.name.split('.').pop().toLowerCase();
            if (fileType === 'xlsx' || fileType === 'xls' || fileType === 'csv') {
                setFileName(file.name);
                handleImport(file, (importedData) => {
                    if (localCurrSec.length === 0) return setImported(importedData);
                    setImported(importedData);
                    const newData = calculateResults(importedData, localCurrSec, vc1Value, vc2Value, vc3Value, lcValue, ldnValue);
                    setDataTable(newData);
                });
            } else {
                return setAlert({
                    visible: true, title: "Atenção!",
                    placeholder: 'É aceito arquivos no formato xlsx, xls, csv.',
                    confirm: false, type: "warning"
                });
            }
        }
    };

    const calculateAndSetResults = () => {
        if (localCurrSec.length === 0 || !imported)
            return setAlert({
                visible: true, title: "Atenção!",
                placeholder: 'É necessário ter um cliente que possua secretaria e um arquivo selecionado.',
                confirm: false, type: "warning"
            });
        const newData = calculateResults(imported, localCurrSec, vc1Value, vc2Value, vc3Value, lcValue, ldnValue);
        setDataTable(newData);
    };

    const handleInputChange = (e) => {
        const rawValue = e.target.value;
        const value = rawValue.replace(/\./g, '').replace(',', '.');
        switch (e.target.name) {
            case "vc1Value":
                setVc1Value(value);
                break;
            case "vc2Value":
                setVc2Value(value);
                break;
            case "vc3Value":
                setVc3Value(value);
                break;
            case "lcValue":
                setLcValue(value);
                break;
            case "ldnValue":
                setLdnValue(value);
                break;
            default:
                break;
        }
    };

    return (
        <>
            <div className="max-w-7xl mx-auto p-6 space-y-8">
                {/* Header */}
                <div className="bg-gradient-to-r from-vox-blue-50 to-vox-green-50 dark:from-vox-blue-900/20 dark:to-vox-green-900/20 border border-vox-blue-200 dark:border-vox-blue-700 rounded-xl p-6 shadow-sm">
                    <div className="flex items-center gap-3 mb-4">
                        <div className="w-12 h-12 bg-vox-blue-500 rounded-lg flex items-center justify-center">
                            <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 00-2 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14" />
                            </svg>
                        </div>
                        <div>
                            <h1 className="text-2xl font-bold text-vox-blue-900 dark:text-vox-blue-100">SAPERX - Relatório de Secretarias</h1>
                            <p className="text-vox-blue-700 dark:text-vox-blue-300">Processamento e análise de dados de telefonia</p>
                        </div>
                    </div>

                    {/* Cliente Select */}
                    <div className="max-w-md">
                        <BaseSelect
                            label="Cliente"
                            name="cliente"
                            value={localClienteSelecionado}
                            onChange={handleSelectClient}
                            options={
                                clientes ?
                                    clientes.slice().sort((a, b) => a?.nome?.localeCompare(b?.nome))
                                    : []}
                            placeholder="Selecione o cliente"
                            valueKey="id"
                            labelKey="nome"
                        />
                    </div>
                </div>

                {/* Configurações de Valores */}
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="w-10 h-10 bg-vox-green-500 rounded-lg flex items-center justify-center">
                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                            </svg>
                        </div>
                        <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Configurações de Valores</h2>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
                        <NumberInput
                            handleInputChange={handleInputChange}
                            dados={{ valor: 0.1023, titulo: "VC1", name: "vc1Value", visible: false, placeholder: "R$" }}
                        />
                        <NumberInput
                            handleInputChange={handleInputChange}
                            dados={{ valor: 0.1023, titulo: "VC2", name: "vc2Value", visible: false, placeholder: "R$" }}
                        />
                        <NumberInput
                            handleInputChange={handleInputChange}
                            dados={{ valor: 0.1136, titulo: "VC3", name: "vc3Value", visible: false, placeholder: "R$" }}
                        />
                        <NumberInput
                            handleInputChange={handleInputChange}
                            dados={{ valor: 0.0341, titulo: "LC", name: "lcValue", visible: false, placeholder: "R$" }}
                        />
                        <NumberInput
                            handleInputChange={handleInputChange}
                            dados={{ valor: 0.0682, titulo: "LDN", name: "ldnValue", visible: false, placeholder: "R$" }}
                        />
                    </div>

                    <div className="flex justify-center">
                        <button
                            onClick={calculateAndSetResults}
                            className="inline-flex items-center px-8 py-4 bg-gradient-to-r from-vox-green-600 to-vox-green-700 hover:from-vox-green-700 hover:to-vox-green-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-green-500 focus:ring-offset-2"
                        >
                            <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                            Calcular Resultados
                        </button>
                    </div>
                </div>

                {/* Upload e Ações */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Upload de Arquivo */}
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="w-10 h-10 bg-vox-blue-500 rounded-lg flex items-center justify-center">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Upload de Arquivo</h2>
                        </div>

                        <div className="space-y-4">
                            <div className="relative">
                                <input
                                    id="file-input"
                                    type="file"
                                    accept=".xlsx, .xls, .csv"
                                    onChange={handleFileChange}
                                    className="hidden"
                                />
                                <label
                                    htmlFor="file-input"
                                    className="flex items-center justify-center w-full h-32 px-4 py-6 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-xl cursor-pointer hover:border-vox-blue-400 dark:hover:border-vox-blue-400 transition-colors duration-200 bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600"
                                >
                                    <div className="text-center">
                                        <svg className="w-12 h-12 mx-auto text-gray-400 dark:text-gray-500 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                                        </svg>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">
                                            <span className="font-medium text-vox-blue-600 dark:text-vox-blue-400">Clique para fazer upload</span> ou arraste e solte
                                        </p>
                                        <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">XLSX, XLS, CSV (máx. 10MB)</p>
                                    </div>
                                </label>
                            </div>

                            {fileName && (
                                <div className="flex items-center gap-3 p-3 bg-vox-green-50 dark:bg-vox-green-900/20 border border-vox-green-200 dark:border-vox-green-700 rounded-lg">
                                    <svg className="w-5 h-5 text-vox-green-600 dark:text-vox-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                    <span className="text-sm font-medium text-vox-green-800 dark:text-vox-green-200">{fileName}</span>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Ações */}
                    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="w-10 h-10 bg-vox-purple-500 rounded-lg flex items-center justify-center">
                                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
                                </svg>
                            </div>
                            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">Ações</h2>
                        </div>

                        <div className="space-y-4">
                            <BaseCheckbox
                                id="myCheckbox"
                                name="myCheckbox"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                label="Remover coluna valor dos relatórios"
                                variant="primary"
                                size="md"
                            />

                            {localCurrSec && localCurrSec.length > 0 && (
                                <button
                                    onClick={downloadAllPdfs}
                                    className="w-full inline-flex items-center justify-center px-6 py-4 bg-gradient-to-r from-vox-red-600 to-vox-red-700 hover:from-vox-red-700 hover:to-vox-red-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-vox-red-500 focus:ring-offset-2"
                                >
                                    <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                    </svg>
                                    Baixar Todos os PDFs
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Loading e Tabela */}
                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg border border-gray-200 dark:border-gray-700 p-6">
                    {localLoading && (
                        <div className="flex items-center justify-center py-12">
                            <LoadingSpinner />
                        </div>
                    )}
                    {localCurrSec && (
                        <DataTable
                            headers={headers}
                            data={dataTable ?? localCurrSec}
                            itemsPerPage={5}
                            exportButton={true}
                            docTitle={`Dados gerais do cliente ${titulo}`}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default Secretarias;
